<template>
  <div class="zhuanxiangtongji">
    <div class="cont_service">
      <div class="cont_title">主要包含服务</div>
      <div class="s_main">
        <div class="m_left wow bounceInLeft">
          <img
            src="../../assets/img/productService/zhuanxiangtongji/poster.png"
            alt="专项统计与统计数据咨询"
          />
        </div>
        <div class="m_right wow bounceInRight">
          <div class="m_title">
            <div class="title_zh">专项统计与统计数据咨询</div>
            <div class="title_en">
              SPECIAL STATISTICS AND STATISTICAL DATA CONSULTATION
            </div>
          </div>
          <ul class="serviceList">
            <li class="s_item">大型普查</li>
            <li class="s_item">行业/部门专项统计调查</li>
            <li class="s_item">统计培训</li>
            <li class="s_item">基础数据采集与监测</li>
            <li class="s_item">统计数据建模</li>
            <li class="s_item">数据研究分析与课题研究</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cont_case wow bounceInUp">
      <div class="cont_title">服务案例</div>
      <div class="c_main">
        <div class="m_info">
          <p>
            近年来承接的专项统计项目主要有：广州市第三次全国农业普查、广州市第四次全国经济普查、广州市第七次全国人口普查、电子商务统计调查、会展业统计调查、文化产业及文化创意产业统计调查、体育产业统计调查、企业就业失业动态监测、广州市营商环境评价调查等；
          </p>
          <p>
            承接的课题主要有：农业普查、经济普查、人口普查课题研究、《贸易领域统计“两防”工作路径探索研究》课题研究等。其中，会展业、体育产业、电子商务、文化产业及文化创意产业的专项数据为政府部门的政策规划及拟定提供了重要的数据支持；相关课题研究获得多部门的好评。
          </p>
          <div class="imgBox">
            <img
              src="../../assets/img/productService/zhuanxiangtongji/1.png"
              alt="..."
            />
            <img
              src="../../assets/img/productService/zhuanxiangtongji/2.png"
              alt="..."
            />
            <img
              src="../../assets/img/productService/zhuanxiangtongji/3.png"
              alt="..."
            />
            <img
              src="../../assets/img/productService/zhuanxiangtongji/4.png"
              alt="..."
            />
            <img
              src="../../assets/img/productService/zhuanxiangtongji/5.png"
              alt="..."
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "zhuanxiangtongji",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.zhuanxiangtongji {
  .cont_title {
    font-size: 18px;
    color: #333333;
    padding: 0 0 0 6px;
    border-left: 6px solid #406cdd;
  }
  .cont_service {
    width: $themeMinWidth;
    margin: 0 auto;
    .s_main {
      display: flex;
      justify-content: space-between;
      padding: 30px 0 0 0;
      .m_left {
        width: 563px;
        height: 234px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .m_right {
        width: 580px;
        .m_title {
          .title_zh {
            font-size: 20px;
            font-weight: bold;
            color: #333333;
          }
          .title_en {
            font-size: 16px;
            color: #999999;
            line-height: 24px;
          }
        }
        .serviceList {
          display: flex;
          flex-wrap: wrap;
          .s_item {
            font-size: 16px;
            color: #333333;
            width: 185px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #ffffff;
            border: solid 1px #e5e5e5;
            margin: 30px 40px 0 0;
          }
        }
      }
    }
  }
  .cont_case {
    padding: 30px 0 0 0;
    .cont_title {
      width: $themeMinWidth;
      margin: 0 auto;
      box-sizing: border-box;
    }
    .c_main {
      background: url("../../assets/img/index/cont_Company.png") center
        no-repeat;
      background-size: cover;
      margin: 30px 0 0 0;
      .m_info {
        width: $themeMinWidth;
        margin: 0 auto;
        padding: 20px 0;
        p {
          text-indent: 32px;
          font-size: 16px;
          color: #666666;
          line-height: 30px;
          text-align: justify;
        }
        .imgBox {
          display: flex;
          justify-content: space-between;
          padding: 30px 0 0 0;
        }
      }
    }
  }
}
</style>
